angular.module('unica_event.event_services')

.factory('EventCreateService', function ($http, getBaseApiURL) {

	var eventCreateService = {};

	eventCreateService.create = function (eventData) {

		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/create',
			data: eventData
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});

	};

	eventCreateService.clone = function (eventId) {

		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/clone/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});

	};

	return eventCreateService;
});